import { render, staticRenderFns } from "./StatusFila.vue?vue&type=template&id=7f12bd3e&"
import script from "./StatusFila.vue?vue&type=script&lang=js&"
export * from "./StatusFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports